import React from "react";
import SettingsCard from "../../Components/SettingsCard/SettingsCard";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import { useNavigate } from "react-router";
import Card from "../../../../components/Card";

const Index = () => {
  console.log("Index component rendering");

  const sections = {
    CamerasBarcodes: {
      items: [
        {
          icon: "storeImage",
          title: "Update Store Image",
          description: "Upload or change the image representing your store",
          fill: "#2A85FF",
           path:"/settingsDashboard/storeSettings/updateStoreImage"
        },
        {
          icon: "storeprint",
          title: "Picklist",
          description:
            "Customize your picklists to make managing orders easier",
          fill: "#2A85FF",
        },
        {
          icon: "sync",
          title: "Sync Orders",
          description:
            "Keep your orders up-to-date by syncing with connected systems",
          fill: "#2A85FF",
          path: "/settingsDashboard/storeSettings/syncOrders",
        },
      ],
      colorClass: "title-blue",
    },
  };

  const navigate = useNavigate();
  return (
    <>
      <Card>
        {Object.entries(sections).map(
          ([sectionName, { items, colorClass }]) => (
            <div key={sectionName}>
              <SectionHeader title={sectionName} colorClass={colorClass} />
              <div
                className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 gap-10"
                style={{ width: "65%", marginBottom: "10px" }}
              >
                {items.map((item) => (
                  <SettingsCard
                    key={item.title}
                    icon={item.icon}
                    title={item.title}
                    description={item.description}
                    className={item.className}
                    onClick={() => navigate(item.path)}
                    fill={item.fill}
                  />
                ))}
              </div>
            </div>
          )
        )}
      </Card>
    </>
  );
};

export default Index;
